import { Culture } from '../../types';

export const blackfoot: Culture = {
  name: 'Blackfoot',
  languageFamily: 'Algic',
  terms: [
    {
      word: 'Oki',
      phonetic: 'oh-kee',
      description: 'Blackfoot greeting meaning "hello."'
    },
    {
      word: 'Aapááhso',
      phonetic: 'ah-pah-soh',
      description: 'Word for "deer" in Blackfoot.'
    },
    {
      word: 'Issksiniip',
      phonetic: 'iss-ksee-neep',
      description: 'Blackfoot term for "teacher."'
    },
    {
      word: 'Niitsitapi',
      phonetic: 'nee-tsee-tah-pee',
      description: 'Term meaning "the real people," used to refer to the Blackfoot people.'
    },
    {
      word: 'Ponoká',
      phonetic: 'poh-no-kah',
      description: 'Blackfoot word for "elk."'
    }
  ]
};